import { QueryClient } from '@tanstack/react-query';
import api from './api';

export interface AddToCartRequest {
  product_id: number;
  quantity: number;
  variation_id?: number;
}

export interface AddToCartResponse {
  success: boolean;
  message?: string;
  cart_id?: number;
  item_count?: number;
  costs?: {
    products_toman?: number;
    delivery_toman?: number;
    total_toman?: number;
    discount_toman?: number;
  };
}

export interface BasketSummaryResponse {
  item_count: number;
  total_items_price: number;
  total_delivery_cost: number;
  last_item_title?: string;
}

// Global query client reference for cart service
let cartQueryClient: QueryClient | null = null;

export const setCartQueryClient = (queryClient: QueryClient) => {
  cartQueryClient = queryClient;
};

export const cartService = {
  async addToCart(request: AddToCartRequest): Promise<AddToCartResponse> {
    try {
      const { data } = await api.post<AddToCartResponse>(
        '/api/cart/add',
        request
      );

      // Update basket summary cache with item_count from response
      if (data.success && cartQueryClient && data.item_count !== undefined) {
        cartQueryClient.setQueryData<BasketSummaryResponse>(
          ['cart', 'summary'],
          {
            item_count: data.item_count,
            total_items_price: data.costs?.products_toman || 0,
            total_delivery_cost: data.costs?.delivery_toman || 0,
          }
        );
      }

      return data;
    } catch (error: any) {
      console.error('Error adding to cart:', error);
      return {
        success: false,
        message: error.response?.data?.detail || error.response?.data?.message || 'متأسفانه یه مشکلی پیش اومد، به سبد خریدت اضافه نشد.',
      };
    }
  },

  async getBasketSummary(): Promise<BasketSummaryResponse> {
    try {
      const { data } = await api.get<BasketSummaryResponse>(
        '/api/cart/summary'
      );
      return data;
    } catch (error: any) {
      console.error('Error fetching basket summary:', error);
      // Return default empty basket on error
      return {
        item_count: 0,
        total_items_price: 0,
        total_delivery_cost: 0,
      };
    }
  },
};

